/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingSettings {
    getFixupPrototypeFunction() { return CostProcessingSettings.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingSettings>): CostProcessingSettings {
        let obj = Object.assign(new CostProcessingSettings(), model);
        CostProcessingSettings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingSettings>): CostProcessingSettings {
        if (!model) return null;
        return CostProcessingSettings.newInstance(<CostProcessingSettings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingSettings) {
        if (!obj) return;

        models.CostProcessingSettings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingSettings): boolean {
        Object.setPrototypeOf(obj, CostProcessingSettings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.max_tag_value_count === undefined) {
            this.max_tag_value_count = 0;
        }
        if (this.number_of_months_to_backfill === undefined) {
            this.number_of_months_to_backfill = 0;
        }
    }

    /**
     * Maximum number of unique values per tag to process for cost allocation tags
     */
    max_tag_value_count: number;

    /**
     * Back filling value for cost processing (in months)
     */
    number_of_months_to_backfill: number;

    /**
     * Whether this account's cost-sync jobs run on dedicated capacity, isolated from the general processing backlog
     */
    is_dedicated_capacity_account: boolean;

}
